module.exports = __webpack_public_path__ + "static/media/Image@2x.69429f44.png";